import { createUseStyles } from 'react-jss';
import { CustomCiamUiTheme } from '../../../theme';

export default createUseStyles(
  {
    root: {
      width: 'fit-content',
      maxWidth: 400,
      padding: [12, 16],
      backgroundColor: '#E6F7FF',
      borderRadius: 4,
      display: 'flex',
      margin: 'auto',
      boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.125);',
      textAlign: 'left',
      marginTop: 24,
      marginBottom: 24,
      position: 'relative',

      '&:before': {
        content: '""',
        width: 4,
        backgroundColor: '#009ACE',
        top: 0,
        left: 0,
        bottom: 0,
        position: 'absolute',
        borderRadius: '2px 0 0 2px',
        zIndex: 2,
      },
    },
    bang: {
      height: 15,
      borderRadius: 4,
      paddingRight: 12,
      paddingTop: 2,
    },
    infoText: {
      fontSize: 15,
    },
    instructionPopover: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      /* bring your own prefixes */
      transform: 'translate(-50%, -50%)',
      background: '#FFF',
      padding: 14,
    },
    providerLink: {
      color: 'white',
      fontSize: '14px !important',
      marginBottom: 24,
      '& a': {
        color: 'white',
        textDecoration: 'underline',
      },
    },
    titleText: {
      fontSize: 15,
      fontWeight: 500,
    },
    link: {
      color: ({ theme }: { theme: CustomCiamUiTheme }) => theme.footerLinkColor,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  {
    name: 'StaffLoginInstruction',
  },
);
